<template>
    <div class="n2-center-container" style="background-color:#fff; padding:10px;">
        <app-content name="web.term.auto_pass"></app-content>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    //import TermReservationEn from '../components/app/text/term-reservation.en.vue'
    //import TermReservationNo from '../components/app/text/term-reservation.no.vue'
    import AppContent from '../components/shared/content.vue';

    export default {
        components: {
            AppContent
            //TermReservationEn,
            //TermReservationNo
        },
        computed: {
            ...mapGetters('globalization', [
                'app_locale',
                'locale',
            ])
        }
    }
</script>
